import axios from "axios";
import { SEMINAR } from "@/seminars";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
// The access token lives in memory only; persistence comes from the httpOnly refresh/access cookies set by the backend.
let accessToken = null;
const LEGACY_TOKEN_KEY = `${SEMINAR.storagePrefix}AdminToken`;
try {
  localStorage.removeItem(LEGACY_TOKEN_KEY); // clean up tokens persisted by earlier builds
} catch (error) {
  if (process.env.NODE_ENV !== "production") console.warn("localStorage unavailable", error);
}

export const publicApi = axios.create({ baseURL: API_BASE });

export const adminApi = axios.create({ baseURL: API_BASE, withCredentials: true });

export const getToken = () => accessToken;
export const setToken = (token) => {
  accessToken = token || null;
};

adminApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
adminApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retried && !original.url.includes("/auth/")) {
      original._retried = true;
      refreshing = refreshing || axios.post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true }).finally(() => (refreshing = null));
      try {
        const { data } = await refreshing;
        setToken(data.access_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return adminApi(original);
      } catch (refreshError) {
        setToken(null);
        if (process.env.NODE_ENV !== "production") console.warn("Session refresh failed", refreshError);
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  const clean = (s) => s.replace(/^Value error,\s*/i, "");
  if (detail == null) return fallback;
  if (typeof detail === "string") return clean(detail);
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? clean(e.msg) : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return clean(detail.msg);
  return String(detail);
}
